// import { object, string, number, bool } from 'yup';

import useCredentials from 'api/hook/useCredentials';

import { baseAxios, handleError } from 'api';
import { useMutation, useQuery } from '@tanstack/react-query';

/**
 * @return {import('@tanstack/react-query').UseQueryResult<any, any>}
 */
export function useUserAddress(userId) {
  const authAxios = useCredentials();
  const queryKey = ['user/address', userId];

  return useQuery({
    queryKey,
    queryFn: () =>
      baseAxios(authAxios, {
        url: 'user/address',
      }),
    onError: (err) => {
      handleError(err);
    },
  });
}

/**
 * @return {import('@tanstack/react-query').UseMutationResult<any, any>}
 */
export function useCreateUserAddress() {
  const authAxios = useCredentials();

  return useMutation({
    mutationFn: (data) => {
      // const {  } = data;
      // delete data.userId;
      return baseAxios(authAxios, {
        url: '/user/address',
        method: 'post',
        data,
      });
    },
    onError: handleError,
  });
}
